<template>
  <div>
    <div
      v-paywall="paywallOptions"
      class="relative"
      :class="[!hasPermission ? 'border border-weak border-solid rounded-md' : '', paywallOptions.showPaywall ? 'max-h-[600px] overflow-hidden' : '']"
    >
      <CustomerProfileDataCapture :v-paywall="paywallConfig" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useStore } from 'vuex'
import CustomerProfileDataCapture from '@/pages/audience/[customer]/view/customerProfileDataCapture.vue'

const store = useStore()
const isFeatureEnabled = computed(() => store.getters['authModule/isFeatureEnabled'])

const isCustomerProfileFeatureEnabled = computed(() => {
  return isFeatureEnabled.value(['customer-profiles'])
})

const hasPermission = computed(() => isCustomerProfileFeatureEnabled.value)

const paywallOptions = computed(() => ({
  showPaywall: !isCustomerProfileFeatureEnabled.value,
  title: 'Unlock data capture information',
  description: 'Track campaign engagement and data capture to see more info about your contacts.',
  buttonText: 'Upgrade Plan',
  buttonIcon: 'rocket',
  linkDestination: '/upgrade',
}))

const paywallConfig = computed(() => {
  return hasPermission.value
    ? null
    : {
        showLockIcon: true,
        title: 'Upgrade to unlock data capture information.',
        description: 'Track campaign engagement and data capture to see more info about your contacts.',
        buttonText: 'Upgrade Now',
        buttonIcon: 'lock-closed',
      }
})
</script>
